export const scopeHelperModule = angular
  .module('Q.helpers.scope-helper', [])

  .factory('scopeHelper', function ($rootScope, $timeout) {
    return {
      wrapCallback(fn, scope = $rootScope) {
        return function (...args) {
          scope.$applyAsync(() => fn(...args));
        };
      },
      oncePerDigest(callback, scope = $rootScope) {
        let unwatch;

        function listenOncePerDigest() {
          if (unwatch || unwatch === false) return;
          unwatch = scope.$watch(() => {
            unwatch();
            unwatch = null;
            callback();
            $timeout(listenOncePerDigest, 0, false);
          });
        }

        listenOncePerDigest();

        return function stop() {
          if (unwatch) unwatch();
          unwatch = false;
        };
      },
    };
  });
